// Lead generators: sites that collect enquiries and sell them on to
// businesses, rather than doing the work themselves.
// To add one, add its website (no https or www) on a new line, e.g.:
//   "example-quotes.co.uk",
export const LEAD_GEN_SITES = [
];
